import { type ReactElement, type ReactNode } from 'react';

import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)(({ theme }) => ({
  height: 32,
  fontSize: 12,
  paddingLeft: 24,
  display: 'flex',
  alignItems: 'center',
  textTransform: 'uppercase',
  color: theme.palette.horizonText.main,
}));

export type SubMenuGroupHeaderProps = {
  children: ReactNode;
};

export const SubMenuGroupHeader = (
  props: SubMenuGroupHeaderProps,
): ReactElement => {
  return <Wrapper>{props.children}</Wrapper>;
};
